import { ReviewService } from "./services/review/reviewService";
import { ProductService } from "./services/product/productService";
import { ReviewApi } from "./shared/api/review/reviewApi";
import { apiInstance } from "./shared/network/base";
import { ProductApi } from "./shared/api/product/productApi";
import { OrderApi } from "./shared/api/order/orderApi";
import { OrderService } from "./services/order/orderService";
import { AuthService } from "./services/auth/authService";
import { TariffApi } from "./shared/api/tariff/tariffApi";
import { TariffService } from "./services/tariff/tariffService";
import { LegalDocumentsApi } from "./shared/api/legalDocuments/legalDocumentsApi";
import { LegalDocumentsService } from "./services/legalDocuments/legalDocumentsService";
const reviewApi = new ReviewApi(apiInstance);
const productApi = new ProductApi(apiInstance);
const orderApi = new OrderApi(apiInstance);
const tariffApi = new TariffApi(apiInstance);
const legalDocumentsApi = new LegalDocumentsApi(apiInstance);
export const authService = new AuthService(apiInstance);
export const reviewService = new ReviewService(reviewApi, authService);
export const productService = new ProductService(productApi, authService);
export const orderService = new OrderService(orderApi);
export const tariffService = new TariffService(tariffApi);
export const legalDocumentsService = new LegalDocumentsService(legalDocumentsApi);
